module.exports = __webpack_public_path__ + "img/6.3.TP.a9148d35.png";